import { put, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { matchRoutes } from 'react-router-config';
import { ALL_FOLDER_NAME, SCRAPS_FOLDER_NAME } from '@wix/da-url';
import { getHomeSectionInitActions } from '../../server/store/initActions/home';
import { getAboutSectionInitActions } from '../../server/store/initActions/about';
import { getGallectionsSectionInitActions } from '../../server/store/initActions/gallections';
import { getShopSectionInitActions } from '../../server/store/initActions/shop';
import { getPostsSectionInitActions } from '../../server/store/initActions/posts';
import { fetchSection, fetchSectionSuccess } from '../actions/sections';
import { routes, getSectionKeys } from '../routes';
import { DEVIATIONS_PER_FETCH_COUNT } from '../streams/folderDeviations';
import { API_BASE_PATH } from '../../server/routes/constants';
import { PapiInitGallectionRequestParams } from '../../types/papi';
import { PostsType } from '../../types/posts';
import { FULLTEXT_JOURNALS_PER_FETCH } from '../streams/posts';

function fetch(section, params) {
  return axios
    .get(`${API_BASE_PATH}/init/${section}`, { params })
    .catch(response => false);
}

export default function* fetchSectionData(action) {
  const { location } = action;

  if (location.state && location.state.withoutSectionLoad) {
    return;
  }

  const routeData = matchRoutes(routes, location.pathname).pop();
  const sectionKey = routeData.route.key;
  const sectionKeys = getSectionKeys();

  if (!sectionKeys.includes(sectionKey)) {
    return;
  }

  yield put(fetchSection(sectionKey));

  const routeParams = routeData.match.params;

  let requestParams;

  switch (sectionKey) {
    case 'gallery':
    case 'favourites':
      const gallectionRequestParams: PapiInitGallectionRequestParams = {
        username: routeParams.username,
        deviations_limit: DEVIATIONS_PER_FETCH_COUNT,
      };

      if (routeParams.folderId !== undefined) {
        gallectionRequestParams.folder_id = routeParams.folderId;
      } else if (routeParams.folderName === ALL_FOLDER_NAME) {
        gallectionRequestParams.all_folder = true;
        if (routeParams.sortOrder) {
          gallectionRequestParams.mode = routeParams.sortOrder;
        }
      } else if (routeParams.folderName === SCRAPS_FOLDER_NAME) {
        gallectionRequestParams.scraps_folder = true;
      }

      requestParams = gallectionRequestParams;
      break;
    case 'shop':
      requestParams = {
        username: routeParams.username,
        shop_section: routeParams.shopSection,
      };
      break;
    case 'posts':
      requestParams = {
        username: routeParams.username,
        posts_section: routeParams.postsSection,
        order: routeParams.sortOrder,
      };
      if (routeParams.postsSection === PostsType.JOURNALS) {
        requestParams.expand = 'deviation.fulltext';
        requestParams.limit = FULLTEXT_JOURNALS_PER_FETCH;
      }
      break;
    default:
      requestParams = {
        username: routeParams.username,
      };
  }

  const result = yield call(fetch, sectionKey, requestParams);

  if (result && result.status === 200) {
    let sectionInitActions;
    switch (sectionKey) {
      case 'about':
        sectionInitActions = getAboutSectionInitActions(result.data);
        break;
      case 'home':
        sectionInitActions = getHomeSectionInitActions(result.data);
        break;
      case 'gallery':
      case 'favourites':
        sectionInitActions = getGallectionsSectionInitActions(
          sectionKey,
          result.data,
          requestParams
        );
        break;
      case 'posts':
        sectionInitActions = getPostsSectionInitActions(
          result.data,
          requestParams
        );
        break;
      case 'shop':
        sectionInitActions = getShopSectionInitActions(
          result.data,
          requestParams
        );
        break;
      default:
        break;
    }
    yield all(
      sectionInitActions.filter(item => item).map(initAction => put(initAction))
    );
    yield put(fetchSectionSuccess(sectionKey));
  }
}
